var _rect, _path, _path2, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScheduler(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 40,
    height: 36,
    rx: 4,
    fill: "#A39090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9V13",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 9V13",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 21,
    width: 34,
    height: 23,
    rx: 2,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0417 24.5C24.8 24.3833 21.325 27.7833 21.325 32H19.8334C19.4584 32 19.275 32.45 19.5417 32.7083L21.8667 35.0417C22.0334 35.2083 22.2917 35.2083 22.4584 35.0417L24.7834 32.7083C25.05 32.45 24.8584 32 24.4917 32H22.9917C22.9917 28.75 25.6417 26.125 28.9084 26.1667C32.0084 26.2083 34.6167 28.8167 34.6584 31.9167C34.7 35.175 32.075 37.8333 28.825 37.8333C27.4834 37.8333 26.2417 37.375 25.2584 36.6C24.925 36.3417 24.4584 36.3667 24.1584 36.6667C23.8084 37.025 23.8334 37.6083 24.225 37.9167C25.4917 38.9083 27.0917 39.5 28.825 39.5C33.0334 39.5 36.4417 36.025 36.325 31.7833C36.2167 27.875 32.95 24.6083 29.0417 24.5ZM28.6167 28.6667C28.275 28.6667 27.9917 28.95 27.9917 29.2917V32.3583C27.9917 32.65 28.15 32.925 28.4 33.075L31 34.6167C31.3 34.7917 31.6834 34.6917 31.8584 34.4C32.0334 34.1 31.9334 33.7167 31.6417 33.5417L29.2417 32.1167V29.2833C29.2417 28.95 28.9667 28.6667 28.6167 28.6667Z",
    fill: "#F26D6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18 22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduler);
export default __webpack_public_path__ + "static/media/scheduler.fd5431a58af9b8aca591ddf725788626.svg";
export { ForwardRef as ReactComponent };